import { seoLinks, absoluteUrl, ogImage } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";

import { PageHero, PolicyBody } from "../components/site/Page";
import { TermsPolicyContent } from "../components/site/EnrollmentPolicyContent";

const title = "Användarvillkor | Swedish International School";
const description =
  "Villkor för att använda sweintschool.com och skolans anmälningsformulär: vad som gäller för uppgifter, avgifter och besked om plats.";

export const Route = createFileRoute("/anvandarvillkor")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl("/anvandarvillkor") },
      { name: "twitter:card", content: "summary" },
      { property: "og:locale", content: "sv_SE" },
      ...ogImage(),
    ],
    links: seoLinks("/anvandarvillkor"),
  }),
  component: Anvandarvillkor,
});

function Anvandarvillkor() {
  return (
    <>
      <PageHero
        eyebrow="Villkor"
        title="Användarvillkor"
        intro="Villkoren gäller när du använder skolans webbplats och när du skickar in en ansökan via formuläret."
      />

      <PolicyBody>
        <TermsPolicyContent locale="sv" />
      </PolicyBody>
    </>
  );
}
